var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"ml-auto mr-auto mt-10",attrs:{"border":"left","colored-border":"","type":"error","elevation":"2","width":"75%"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }